import { render, staticRenderFns } from "./hk6.vue?vue&type=template&id=280f0020"
import script from "./hk6.vue?vue&type=script&lang=js"
export * from "./hk6.vue?vue&type=script&lang=js"
import style0 from "./hk6.vue?vue&type=style&index=0&id=280f0020&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports